import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PageHeading from './PageHeading';
import SectionButtons from './SectionButtons';
import './TrainingAdmin.css';

export function TrainingAdminShell({ section, children }) {
    const history = useHistory();
    const location = useLocation();
    const headings = {
        trainings: { title: 'Treinamentos', description: 'Organize a capacitação dos fiscais e acompanhe a aprendizagem.', icon: 'training' },
        modules: { title: 'Módulos', description: 'Agrupe os conteúdos e defina a sequência de aprendizagem.', icon: 'modules' },
        contents: { title: 'Conteúdos', description: 'Cadastre vídeos, PDFs e questões para a capacitação dos fiscais.', icon: 'contents' },
    };
    const isListPage = ['/treinamentos', '/modulos', '/conteudos'].includes(location.pathname.replace(/\/$/, ''));
    const heading = isListPage ? headings[section] : { title: 'Gestão de treinamentos', description: 'Prepare os materiais, organize os módulos e acompanhe a aprendizagem dos fiscais.', icon: 'training' };
    const items = [
        { value: 'trainings', label: 'Treinamentos', icon: 'treinamentos', description: 'Organize a capacitação e vincule os fiscais.' },
        { value: 'modules', label: 'Módulos', icon: 'modulos', description: 'Agrupe e ordene os conteúdos de aprendizagem.' },
        { value: 'contents', label: 'Conteúdos', icon: 'conteudos', description: 'Cadastre vídeos, PDFs e questões de avaliação.' },
    ];
    return <div className="training-admin">
        <header className="card training-admin-heading hidethis"><div className="card-body">
            <PageHeading {...heading} />
            <SectionButtons items={items} value={section} compact variant="modules" label="Gestão de treinamentos" onChange={value => history.push({ trainings: '/treinamentos', modules: '/modulos', contents: '/conteudos' }[value])} />
        </div></header>
        <div className="training-admin-workspace">{children}</div>
    </div>;
}

export default function withTrainingAdminShell(Component, section) {
    return function TrainingAdminScreen(props) {
        return <TrainingAdminShell section={section}><Component {...props} /></TrainingAdminShell>;
    };
}
